module.exports = __webpack_public_path__ + "1793882494189/fonts/Flaticon.5b09159.ttf";